import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { Habit } from 'src/app/habit.model';

@Component({
  selector: 'app-habit',
  templateUrl: './habit.component.html',
  styleUrls: ['./habit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HabitComponent implements OnInit {
  @Input()
  habit: Habit = { id: '', name: '', date: 0 };

  @Input()
  showStrikes = true;

  @Output()
  habitTap: EventEmitter<boolean> = new EventEmitter();

  @Output()
  habitPress: EventEmitter<boolean> = new EventEmitter();

  @Output()
  delete: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  emitHabitTap(): void {
    this.habitTap.emit(true);
  }

  emitHabitPress(): void {
    this.habitPress.emit(true);
  }

  emitDelete(): void {
    this.delete.emit(true);
  }
}
